import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Skeleton } from "antd";
import { WarningFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getPaneIndex } from "../../../redux/constants";
import isEqual from "react-fast-compare";

import AccountNoData from "../../../assets/no_data-config.svg";
import DeepInsights from "../../../assets/AIGeneratedInsights/Deep_Insights.svg";
import PeakGray from "../../../assets/AIGeneratedInsights/Peak_Gray.svg";
import Peakgreen from "../../../assets/AIGeneratedInsights/Peak_green.svg";
import Peakwhite from "../../../assets/AIGeneratedInsights/Peak_white.svg";
import PeakBlue from "../../../assets/AIGeneratedInsights/Peak_Blue.svg";
import ValleyGray from "../../../assets/AIGeneratedInsights/Valley_Gray.svg";
import ValleyRed from "../../../assets/AIGeneratedInsights/Valley_Red.svg";
import Valley_Blue from "../../../assets/AIGeneratedInsights/Valley_Blue.svg";
import Valleywhite from "../../../assets/AIGeneratedInsights/Valley_white.svg";

import { setWidgetAIGeneratedInsightsOpenStatus } from "../../../redux/actions/dashboard/Tab1";
import {
  setAIGeneratedInsights,
  setAIInsightStatus,
  setDeeperAIInsightStatus,
} from "../../../redux/actions/PPT";
import { setOptionHighChart } from "../../../redux/actions/HighChart";

import WidgetMakerChart from "../../WidgetMaker/Chart";
import PromptText from "./PromptText";

const AIInsightsModal = () => {
  const dispatch = useDispatch();
  const nodeRef = useRef();
  const [isDeaperinstights, setDeaperinstights] = useState("peak");
  const [AiInsightsdata, setAiInsightsdata] = useState(null);
  const [chartLoader, setChartLoader] = useState(false);
  const opData = useSelector((state) => state.Highchart.Options);

  const aiInsightsStatus = useSelector((state) => state.PPT.aiInsightsStatus);
  const aiDeeperInsightsStatus = useSelector(
    (state) => state.PPT.aiDeeperInsightsStatus
  );
  const deeperAIInsightLoader = useSelector(
    (state) => state.PPT.deeperAIInsightLoader
  );
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state.Tab1.panes);
  let index = getPaneIndex(panes, activeKey);
  const aiInsightsLoader = useSelector((state) => state.PPT.aiInsightsLoader);
  const authParams = useSelector((state) => state.Authentication.authParams);

  const handelLoader = () => {
    const handler = setTimeout(() => {
      setChartLoader(false);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  };
  useEffect(() => {
    setChartLoader(true);
    const sectionsData =
      panes?.[index]?.sections?.[aiInsightsStatus?.section_index]?.widgets?.[
        aiInsightsStatus?.widget_index
      ];
    const widgetSData =
      panes?.[index]?.section?.[0]?.widgets?.[aiInsightsStatus?.widget_index];
    if (sectionsData) {
      setAiInsightsdata(sectionsData);
    } else setAiInsightsdata(widgetSData);
    handelLoader();
  }, [aiInsightsStatus?.open]);

  const getDeepInsights = (text, topKey, prompt_text) => {
    let widget = {
      aiDeeperInsightsStatus: aiDeeperInsightsStatus,
      graphData: AiInsightsdata?.graphData,
      widget_id: AiInsightsdata?.widget_id,
      dashboard_name: panes?.[index]?.template_name,
      section_name: AiInsightsdata?.section_name,
      prompt_text: prompt_text
        ? prompt_text
        : AiInsightsdata?.insights?.[0]?.prompt,
      insight_type: text,
      insight_type_lable: topKey ? topKey : isDeaperinstights,
    };

    dispatch(
      setDeeperAIInsightStatus(AiInsightsdata?.payload, widget, authParams)
    );
    let handler = setTimeout(() => {
      nodeRef.current &&
        nodeRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 3000);
    return () => {
      clearTimeout(handler);
    };
  };
  const handleOk = () => {
    dispatch(
      setAIInsightStatus({
        open: false,
        section_index: null,
        widget_index: null,
      })
    );
    let d = {
      peak: { data: null, level_1: null, level_2: null },
      valley: { data: null, level_1: null, level_2: null },
      top_key: { level_1: null, level_2: null },
    };
    dispatch({
      type: "SET_DEEPER_AI_INSIGHTS_STATUS",
      payload: d,
    });
    dispatch(
      setWidgetAIGeneratedInsightsOpenStatus(
        false,
        index,
        panes,
        aiInsightsStatus?.section_index,
        aiInsightsStatus?.widget_index,
        true
      )
    );

    setAiInsightsdata(null);
    let updateOptions = { ...opData };
    if (updateOptions[AiInsightsdata?.widget_id]) {
      delete updateOptions[AiInsightsdata?.widget_id];
      dispatch(setOptionHighChart(updateOptions));
    }
  };
  const handleAiTabs = (text) => {
    setDeaperinstights(text);
    let pp = aiDeeperInsightsStatus?.[text];
    if (pp?.data?.length > 0) {
    } else {
      getDeepInsights(text, text);
    }
  };
  const callInsights = (promptText) => {
    let sections = panes[index]?.sections
      ? panes[index]?.sections
      : panes[index]?.section;
    let payload =
      sections?.[
        aiInsightsStatus?.section_index > 0
          ? aiInsightsStatus?.section_index
          : 0
      ]?.widgets[aiInsightsStatus?.widget_index]?.payload;
    let widget = {
      pane_index: index,
      panes: panes,
      section_index: panes[index]?.sections
        ? aiInsightsStatus?.section_index
        : null,
      widget_index: aiInsightsStatus?.widget_index,
      widget_id:
        sections?.[
          aiInsightsStatus?.section_index > 0
            ? aiInsightsStatus?.section_index
            : 0
        ]?.widgets[aiInsightsStatus?.widget_index]?.widget_id,
      dashboard_name: panes?.[index]?.template_name,
      prompt_text: promptText,
    };
    dispatch(
      setWidgetAIGeneratedInsightsOpenStatus(
        true,
        index,
        panes,
        widget?.section_index,
        widget?.widget_index
      )
    );

    if (payload && promptText) {
      payload && dispatch(setAIGeneratedInsights(payload, widget, authParams));
    }
  };

  const handleEnter = (prompt_text, id) => {
    if (id === "top_key") {
      callInsights(prompt_text);
    } else if (id === "top_key_level_1") {
      getDeepInsights("level-1", "TopKeyInsights", prompt_text);
    } else if (id === "top_key_level_2") {
      getDeepInsights("level-2", "TopKeyInsights", prompt_text);
    } else if (id === "peak") {
      getDeepInsights("peak", null, prompt_text);
    }
  };
  return (
    <Modal
      title={
        <div className="portlet__title font-weight 500">
          {AiInsightsdata?.widget_name}
        </div>
      }
      visible={aiInsightsStatus?.open}
      //onOk={handleOk}
      okButtonProps={
        chartLoader || aiInsightsLoader?.value ? { disabled: false } : {}
      }
      onCancel={handleOk}
      footer={null}
      width="90%"
      style={{ top: "3rem" }}
      className={`aiInsightsStatusModal ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
    >
      <div className="portlet border-bottom border-color">
        {chartLoader ? (
          <div className="loader text-center w-100" style={{ height: "45rem" }}>
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : (
          <div style={{ minHeight: "44.5rem" }}>
            {" "}
            <WidgetMakerChart
              //previewCardBoxStyle={styles}
              metaWidgetConfig={AiInsightsdata}
              widget_index={aiInsightsStatus?.widget_index}
              section_index={aiInsightsStatus?.section_index}
              metaWidgetGraphData={
                AiInsightsdata?.graphData?.data[
                  AiInsightsdata?.graph_type === "horizontal-bar"
                    ? "bar"
                    : AiInsightsdata?.graph_type
                ]
              }
              dashboard={true}
              AiInsights={true}
              //metaWidgetKpiData={AiInsightsdata?.graphData?.data}
              id={AiInsightsdata?.widget_id}
              span_data="full"
            />
          </div>
        )}
      </div>
      <div className="row m-0">
        <div className="col-12 col-md-6 p-0 border-right border-color">
          <div className="p-15">
            <div className="font-weight600 fontSize-14 text_heading mb-15">
              Top Key Insights
            </div>
            {aiInsightsLoader?.value ? (
              <Skeleton />
            ) : (
              <div
                className={`w-100 custom_scroll1`}
                style={{ maxHeight: "30rem", overflow: "auto" }}
              >
                {typeof AiInsightsdata?.insights === "string" ? (
                  <>
                    <PromptText
                      data={AiInsightsdata?.insights?.[0]?.prompt}
                      id="top_key"
                      handleEnter={handleEnter}
                      aiLoader={deeperAIInsightLoader?.loader}
                    />

                    <div
                      className="d-flex align-items-center justify-content-center w-100"
                      style={{ minHeight: "20rem" }}
                    >
                      {" "}
                      <div className="error text-center">
                        <WarningFilled className="font-size30 d-block w-100 mb-2" />{" "}
                        {AiInsightsdata?.insights}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <PromptText
                      data={AiInsightsdata?.insights?.[0]?.prompt}
                      id="top_key"
                      handleEnter={handleEnter}
                      aiLoader={deeperAIInsightLoader?.loader}
                    />
                    {AiInsightsdata?.insights?.[0]?.ai_generated_insights?.map(
                      (el, i) => {
                        return (
                          <div
                            key={`list_${i}`}
                            className="mb-15 d-flex text_regular-gray"
                          >
                            <span className="mr-1" style={{ color: "#1C9F00" }}>
                              {i + 1}.
                            </span>{" "}
                            {el}
                          </div>
                        );
                      }
                    )}
                  </>
                )}

                <span
                  className={`blue-text cursor-pointer align-items-baseline pl-15 ${
                    deeperAIInsightLoader?.loader ? "disable" : ""
                  } ${
                    typeof AiInsightsdata?.insights === "string" ||
                    aiDeeperInsightsStatus?.top_key?.level_1?.length > 0 ||
                    typeof aiDeeperInsightsStatus?.top_key?.level_1?.reason ===
                      "string"
                      ? "d-none"
                      : "d-inline-flex"
                  }`}
                  onClick={() => getDeepInsights("level-1", "TopKeyInsights")}
                >
                  <img src={DeepInsights} alt="DeepInsights" /> Deeper Insights
                </span>
                {deeperAIInsightLoader?.insight_type === "level-1" &&
                deeperAIInsightLoader?.loader ? (
                  <Skeleton />
                ) : (
                  (aiDeeperInsightsStatus?.top_key?.level_1?.length > 0 ||
                    typeof aiDeeperInsightsStatus?.top_key?.level_1?.reason ===
                      "string") && (
                    <div className="bg__gray p-15">
                      <div className="green-text font-weight600 ml-2 mb-1">
                        {" "}
                        Deeper Insights{" "}
                      </div>
                      {typeof aiDeeperInsightsStatus?.top_key?.level_1
                        ?.reason === "string" ? (
                        <>
                          <PromptText
                            data={
                              aiDeeperInsightsStatus?.top_key?.level_1_prompt
                            }
                            id="top_key_level_1"
                            handleEnter={handleEnter}
                            aiLoader={deeperAIInsightLoader?.loader}
                          />

                          <div
                            className="d-flex align-items-center justify-content-center w-100"
                            style={{ minHeight: "20rem" }}
                          >
                            {" "}
                            <div className="error text-center">
                              <WarningFilled className="font-size30 d-block w-100 mb-2" />{" "}
                              {aiDeeperInsightsStatus?.top_key?.level_1?.reason}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <PromptText
                            data={
                              aiDeeperInsightsStatus?.top_key?.level_1_prompt
                            }
                            id="top_key_level_1"
                            handleEnter={handleEnter}
                            aiLoader={deeperAIInsightLoader?.loader}
                          />
                          {aiDeeperInsightsStatus?.top_key?.level_1?.map(
                            (el, i) => {
                              return (
                                <div
                                  key={`list_${i}`}
                                  className="mb-15 ml-2 d-flex text_regular-gray"
                                >
                                  <span className="mr-1 green-text">
                                    {i + 1}.
                                  </span>{" "}
                                  {el}
                                </div>
                              );
                            }
                          )}
                        </>
                      )}
                      <span
                        className={`blue-text cursor-pointer align-items-baseline pl-15  ${
                          deeperAIInsightLoader?.loader ? "disable" : ""
                        } ${
                          typeof aiDeeperInsightsStatus?.top_key?.level_1
                            ?.reason === "string" ||
                          aiDeeperInsightsStatus?.top_key?.level_2?.length >
                            0 ||
                          typeof aiDeeperInsightsStatus?.top_key?.level_2
                            ?.reason === "string"
                            ? "d-none"
                            : "d-inline-flex"
                        }`}
                        onClick={() =>
                          getDeepInsights("level-2", "TopKeyInsights")
                        }
                      >
                        <img src={DeepInsights} alt="DeepInsights" /> Deepest
                        Insights
                      </span>
                    </div>
                  )
                )}
                {deeperAIInsightLoader?.insight_type === "level-2" &&
                deeperAIInsightLoader?.loader ? (
                  <div id="level-2">
                    <Skeleton />
                  </div>
                ) : (
                  (aiDeeperInsightsStatus?.top_key?.level_2?.length > 0 ||
                    typeof aiDeeperInsightsStatus?.top_key?.level_2?.reason ===
                      "string") && (
                    <div className="bg__grays p-15">
                      <div
                        className="font-weight600 ml-4 mb-1"
                        style={{ color: "#105900" }}
                      >
                        {" "}
                        Deepest Insights{" "}
                      </div>
                      {typeof aiDeeperInsightsStatus?.top_key?.level_2
                        ?.reason === "string" ? (
                        <>
                          {" "}
                          <PromptText
                            data={
                              aiDeeperInsightsStatus?.top_key?.level_2_prompt
                            }
                            id="top_key_level_2"
                            handleEnter={handleEnter}
                            aiLoader={deeperAIInsightLoader?.loader}
                          />
                          <div
                            className="d-flex align-items-center justify-content-center w-100"
                            style={{ minHeight: "20rem" }}
                          >
                            {" "}
                            <div className="error text-center">
                              <WarningFilled className="font-size30 d-block w-100 mb-2" />{" "}
                              {aiDeeperInsightsStatus?.top_key?.level_2?.reason}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <PromptText
                            data={
                              aiDeeperInsightsStatus?.top_key?.level_2_prompt
                            }
                            id="top_key_level_2"
                            handleEnter={handleEnter}
                            aiLoader={deeperAIInsightLoader?.loader}
                          />
                          {aiDeeperInsightsStatus?.top_key?.level_2?.map(
                            (el, i) => {
                              return (
                                <div
                                  key={`list_${i}`}
                                  className="mb-15 ml-4 d-flex text_regular-gray"
                                >
                                  <span
                                    className="mr-1"
                                    style={{ color: "#105900" }}
                                  >
                                    {i + 1}.
                                  </span>{" "}
                                  {el}
                                </div>
                              );
                            }
                          )}
                        </>
                      )}
                    </div>
                  )
                )}
                <div ref={nodeRef} style={{ visibility: "hidden" }} />
              </div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-6 pl-0 pr-0">
          <div
            className={
              (deeperAIInsightLoader?.insight_type === "peak" &&
                deeperAIInsightLoader?.loader) ||
              (deeperAIInsightLoader?.insight_type === "valley" &&
                deeperAIInsightLoader?.loader) ||
              aiDeeperInsightsStatus?.peak?.data?.length > 0 ||
              typeof aiDeeperInsightsStatus?.peak?.data?.reason === "string" ||
              aiDeeperInsightsStatus?.valley?.data?.length > 0 ||
              typeof aiDeeperInsightsStatus?.valley?.data?.reason === "string"
                ? "d-none"
                : aiInsightsLoader?.value ||
                  ((deeperAIInsightLoader?.insight_type === "peak" ||
                    deeperAIInsightLoader?.insight_type === "level-1" ||
                    deeperAIInsightLoader?.insight_type === "level-2") &&
                    deeperAIInsightLoader?.loader)
                ? "disable text-center p-15"
                : "text-center p-15"
            }
          >
            <div className="font-weight600 fontSize-14 text_heading mb-2">
              Highlights
            </div>
            <div className="text_regular-gray mb-15">
              Get Deeper Insights Of This Graph As
              <br /> Peak And Valley
            </div>
            <div className="d-flex justify-content-center mb-15 Insights_list">
              <Button
                className={`aiBtn ${
                  isDeaperinstights === "peak" ? "peak" : ""
                }`}
                onClick={() => setDeaperinstights("peak")}
              >
                {" "}
                <img
                  src={
                    isDeaperinstights === "peak"
                      ? Peakgreen
                      : authParams?.theme_type === "1"
                      ? Peakwhite
                      : PeakGray
                  }
                  alt="DeepInsights"
                  className="mr-1"
                />{" "}
                Peak
              </Button>
              <Button
                className={`aiBtn ${
                  isDeaperinstights === "valley" ? "valley" : ""
                }`}
                onClick={() => setDeaperinstights("valley")}
              >
                <img
                  src={
                    isDeaperinstights === "valley"
                      ? ValleyRed
                      : authParams?.theme_type === "1"
                      ? Valleywhite
                      : ValleyGray
                  }
                  alt="DeepInsights"
                  className="mr-1"
                />{" "}
                Valley
              </Button>
            </div>
            <Button
              className="ant-btn-primary_blue"
              onClick={() => getDeepInsights(isDeaperinstights)}
            >
              Get Deep Insights
            </Button>
          </div>
          {deeperAIInsightLoader?.insight_type === "peak" &&
          deeperAIInsightLoader?.loader ? (
            <Skeleton className="ml-15 aiInsight_loader" />
          ) : (
            (aiDeeperInsightsStatus?.peak?.data?.length > 0 ||
              typeof aiDeeperInsightsStatus?.peak?.data?.reason === "string") &&
            isDeaperinstights === "peak" && (
              <div
                className="w-100 custom_scroll1"
                style={{ maxHeight: "35.5rem", overflow: "auto" }}
              >
                <div className="DeeperInsights_head pl-15 pr-15 d-flex justify-content-between mt-15 mb-15">
                  <div className="green-text font-weight600">
                    <img src={Peakgreen} alt="PeakGray" /> Peak Insights
                  </div>
                  <div
                    className={`blue-text cursor-pointer ${
                      deeperAIInsightLoader?.loader ? "disable" : ""
                    }`}
                    onClick={() => handleAiTabs("valley")}
                  >
                    {" "}
                    <img src={Valley_Blue} alt="Valley_Blue" /> Change To Valley
                  </div>
                </div>
                {typeof aiDeeperInsightsStatus?.peak?.data?.reason ===
                "string" ? (
                  <>
                    <PromptText
                      data={aiDeeperInsightsStatus?.peak?.prompt}
                      id="peak"
                      handleEnter={handleEnter}
                      aiLoader={deeperAIInsightLoader?.loader}
                    />
                    <div
                      className="d-flex align-items-center justify-content-center w-100"
                      style={{ minHeight: "20rem" }}
                    >
                      {" "}
                      <div className="error text-center">
                        <WarningFilled className="font-size30 d-block w-100 mb-2" />{" "}
                        {aiDeeperInsightsStatus?.peak?.data?.reason}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <PromptText
                      data={aiDeeperInsightsStatus?.peak?.prompt}
                      id="peak"
                      handleEnter={handleEnter}
                      aiLoader={deeperAIInsightLoader?.loader}
                    />
                    {aiDeeperInsightsStatus?.peak?.data?.map((el, i) => {
                      return (
                        <div
                          key={`list_${i}`}
                          className="mb-15 pl-15 d-flex text_regular-gray"
                        >
                          <span className="mr-1 green-text">{i + 1}.</span> {el}
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            )
          )}

          {deeperAIInsightLoader?.insight_type === "valley" &&
          deeperAIInsightLoader?.loader ? (
            <Skeleton className="ml-15 aiInsight_loader" />
          ) : (
            (aiDeeperInsightsStatus?.valley?.data?.length > 0 ||
              typeof aiDeeperInsightsStatus?.valley?.data?.reason ===
                "string") &&
            isDeaperinstights === "valley" && (
              <div
                className="w-100 custom_scroll1"
                style={{ maxHeight: "35.5rem", overflow: "auto" }}
              >
                {typeof aiDeeperInsightsStatus?.valley?.data?.reason ===
                  "string" ||
                aiDeeperInsightsStatus?.valley?.data?.length > 0 ? (
                  <>
                    <div className="DeeperInsights_head pl-15 pr-15 d-flex justify-content-between mt-15 mb-15">
                      <div className="error font-weight600">
                        <img src={ValleyRed} alt="PeakGray" /> Valley Insights
                      </div>
                      <div
                        className={`blue-text cursor-pointer ${
                          deeperAIInsightLoader?.loader ? "disable" : ""
                        }`}
                        onClick={() => handleAiTabs("peak")}
                      >
                        {" "}
                        <img src={PeakBlue} alt="PeakBlue" /> Change To Peak
                      </div>
                    </div>
                    {typeof aiDeeperInsightsStatus?.valley?.data?.reason ===
                    "string" ? (
                      <div
                        className="d-flex align-items-center justify-content-center w-100"
                        style={{ minHeight: "20rem" }}
                      >
                        {" "}
                        <div className="error text-center">
                          <WarningFilled className="font-size30 d-block w-100 mb-2" />{" "}
                          {aiDeeperInsightsStatus?.valley?.data?.reason}
                        </div>
                      </div>
                    ) : (
                      aiDeeperInsightsStatus?.valley?.data?.map((el, i) => {
                        return (
                          <div
                            key={`list_${i}`}
                            className="mb-15 pl-15 d-flex text_regular-gray"
                          >
                            <span className="mr-1 green-text">{i + 1}.</span>{" "}
                            {el}
                          </div>
                        );
                      })
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            )
          )}
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(AIInsightsModal, isEqual);
